import * as React from "react";
import {
  withStyles,
  CssBaseline,
  createMuiTheme,
  MuiThemeProvider,
  Grid,
  Button,
  Snackbar,
} from "@material-ui/core";
import MenuTheme from "modules/menu/components/pages/MenuTheme";
import { ErrorException } from "common/exception/Exception";
import { ExceptionStore } from "common/exception/ExceptionStore";
import { observer } from "mobx-react";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";
import TopBar from "modules/menu/components/layouts/TopBar";

const theme = createMuiTheme(MenuTheme);

const styles = (theme) => ({
  inside: {
    backgroundColor: theme.palette.secondary.main,
    height: "100%",
  },
  tabletWidth: {
    minWidth: "1024px",
  },
});

type IProps = {
  classes: any;
};

@observer
class Menu extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  handleClose = () => {
    LoginStore.firstLogin = false;
  };

  public render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />

        <Grid className={classes.tabletWidth} container>
          <Grid item xs={12}>
            <TopBar />
          </Grid>
          <Grid item xs={12}>
            {this.props.children}
          </Grid>
        </Grid>

        <ErrorException
          open={ExceptionStore.open}
          close={() => {
            ExceptionStore.CloseException();
          }}
          variant={"error"}
          message={ExceptionStore.message}
        />

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={LoginStore.firstLogin}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={
            <span id="message-id">
              {i18n.login.emailConfirmation1}
              <br />
              {i18n.login.emailConfirmation2}
            </span>
          }
          action={[
            <Button
              key="undo"
              color="primary"
              size="small"
              onClick={this.handleClose}
            >
              {i18n.gotIt}
            </Button>,
          ]}
        />
        <ErrorException
          className={classes.margin}
          open={ExceptionStore.open}
          close={() => {
            ExceptionStore.CloseException();
          }}
          variant={"error"}
          message={ExceptionStore.message}
        />
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(Menu);



// WEBPACK FOOTER //
// ./src/modules/menu/components/pages/Menu.tsx